import type { ReactNode } from 'react'
import '../premium.css'

export function PremiumLegacySurface({
  children,
}: {
  readonly children: ReactNode
}) {
  return (
    <div className="premiumResponsiveSurface">{children}</div>
  )
}
